import {
  RESIDENCY_LINK_ICON_NAMES,
  ResidencyLinkIconName,
} from '@/modules/residency/constants/ResidencyExternalLinkIcons'

import { ResidencyExternalLinkRead, ResidencyRead } from '@generated/types'

export const SOCIAL_ICON_NAMES: ReadonlyArray<ResidencyLinkIconName> =
  RESIDENCY_LINK_ICON_NAMES.filter((name): name is ResidencyLinkIconName => name !== 'link')

export function socialUrlsFromLinks(links: ResidencyExternalLinkRead[] | undefined): string[] {
  if (!links?.length) return []
  return links
    .filter(link => (SOCIAL_ICON_NAMES as readonly string[]).includes(link.icon))
    .filter(link => /^https?:\/\//i.test(link.url))
    .map(link => link.url)
}

export function buildResidencyJsonLd(residency: ResidencyRead | null | undefined): string | null {
  if (!residency) return null
  const sortedLinks = [...(residency.external_links ?? [])].sort(
    (a, b) => a.position - b.position,
  )
  const sameAs = socialUrlsFromLinks(sortedLinks)
  if (sameAs.length === 0) return null
  // Escape chars that would break out of <script type="application/ld+json"> via v-html.
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'PerformingGroup',
    name: residency.name,
    sameAs,
  })
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}
